import StudyTaskModel from '@/Models/StudyTaskModel';

/**
 * Map remote StudyTask to local
 * @param {object} dtoStudyTask
 * @returns {StudyTaskModel}
 */
export const StudyTaskResponse = dtoStudyTask => {
  return new StudyTaskModel(dtoStudyTask);
};

/**
 * Map remote StudyTasks to local
 * @param {object[]} dtoStudyTasks
 * @returns {StudyTaskModel[]}
 */
export const StudyTasksResponse = dtoStudyTasks => {
  return dtoStudyTasks.map(dto => StudyTaskResponse(dto));
};
